import { useOutletContext } from 'react-router-dom';

import { useKiosks } from 'lib/hooks/queries/kiosks/useKiosks';

import EditKioskModal from './lib/Edit/EditKioskModal';
import NewKioskModal from './lib/New/NewKioskModal';

const KioskModal = ({ isOpen, handleClose, item }) => {
  const { practice } = useOutletContext();
  const { data } = useKiosks({ params: { practiceId: practice.id } });

  return (
    <>
      {!item ? (
        <>
          <NewKioskModal
            isOpen={isOpen}
            handleClose={handleClose}
            kioskNr={(data?.kiosks?.length || 0) + 1}
            kiosks={data?.kiosks}
          />
        </>
      ) : (
        <EditKioskModal kiosk={item} setKiosk={handleClose} />
      )}
    </>
  );
};

export default KioskModal;
